import React from 'react';
import testimonial1 from '../media/testimonial1.jpg'
import testimonial2 from '../media/testimonial2.jpg'
import testimonial3 from '../media/testimonial3.jpg'
import testimonial4 from '../media/testimonial4.jpg'


export default function Testimonial() {
    return (
        <div className='testimonial'>
            <section id="feature" className="feature">
                <div className="container">
                    <div className="section-header">
                        <h2>What parent says</h2>
                    </div>
                    <div className="feature-content" >
                        <div className="row">
                            <div className="col-md-3 col-sm-6 col-xs-6" style={{ height: '504.66px' }}>
                                <div className="single-feature">
                                    <img className='image' src={testimonial1} alt="feature image" />
                                    <div className="single-feature-txt text-center">
                                        <p>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <span className="feature-review">(20 review)</span>
                                        </p>
                                        <h3><a href="#">Priya Gaur</a></h3>
                                        <p className='text-justify'>
                                            "Kidorise nappies are soft, breathable, and perfect for my newborn. I trust them completely for daily baby care."
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 col-xs-6" style={{ height: '504.66px' }}>
                                <div className="single-feature">
                                    <img className='image' src={testimonial2} alt="feature image" />
                                    <div className="single-feature-txt text-center">
                                        <p>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                                            <span className="feature-review">(45 review)</span>
                                        </p>
                                        <h3><a href="#">Suman Dhaiya</a></h3>
                                        <p className='text-justify'>
                                            "Kidorise products are thoughtfully made. My baby stays dry and happy all day. Highly recommend for all new parents!"                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 col-xs-6" style={{ height: '504.66px' }}>
                                <div className="single-feature">
                                    <img className='image' src={testimonial3} alt="feature image" />
                                    <div className="single-feature-txt text-center">
                                        <p>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                                            <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                                            <span className="feature-review">(10 review)</span>
                                        </p>
                                        <h3><a href="#">Anjali Kumari</a></h3>
                                        <p className='text-justify'>
                                            "The packaging, softness, and fit are excellent. Kidorise has become a daily essential in our parenting routine."
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 col-xs-6" style={{ height: '504.66px' }}>
                                <div className="single-feature border">
                                    <img className='image' src={testimonial4} alt="feature image" />
                                    <div className="single-feature-txt text-center">
                                        <p>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                                            <span className="feature-review">(12 review)</span>
                                        </p>
                                        <h3><a href="#">Aishley Roy</a></h3>
                                        <p className='text-justify' >
                                            "As a new parent, Kidorise made things easier. Reliable products, gentle on skin, and delivered quickly every time."
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
